import $ from "jquery";

export class CookieOv {

    constructor() {
        (<any>window).CookieOv = this;

        $(document).ready(function () {
            (<any>window).CookieOv.initCookieOverlay();

            $(".cookieopschange").click(function (e) {
                e.preventDefault();
                $.ajax({
                    url: "/cookieopts",
                    success: function (data) {
                        $("#cookie-select-overlay").remove();
                        $("BODY").append(data);
                        (<any>window).CookieOv.initCookieOverlay();
                    }
                });
            });

            $("#changecookieopts").click(function (e) {
                e.preventDefault();
                $.ajax({
                    url: "/cookieopts",
                    success: function (data) {
                        $("#cookie-select-overlay").remove();
                        $("BODY").append(data);
                        (<any>window).CookieOv.initCookieOverlay();
                    }
                });
            });

            $("#changecookieopts_mobile").click(function (e) {
                e.preventDefault();
                $.ajax({
                    url: "/cookieopts",
                    success: function (data) {
                        $("#cookie-select-overlay").remove();
                        $("BODY").append(data);
                        (<any>window).CookieOv.initCookieOverlay();
                    }
                });
            });
        });
    }

    initCookieOverlay() {
        $(".tickbox").click(function (e) {
            e.preventDefault();
            if ($(this).hasClass("dis"))
                return;

            if ($(this).hasClass("ticked")) {
                $(this).removeClass("ticked");
            } else {
                $(this).addClass("ticked");
            }
        })

        $("#cookie-select-overlay .stdbtn").click(function (e) {
            e.preventDefault();
            if ($(this).hasClass("stdbtn-primary")) {
                $("#tb-statistik").addClass("ticked");
                $("#tb-komfort").addClass("ticked");
            }

            $.ajax({
                url: '/cookieaccept',
                data: { "statistik": $("#tb-statistik").hasClass("ticked"), "komfort": $("#tb-komfort").hasClass("ticked") },
                method: "POST",
                success: function (data) {
                    $("#cookie-select-overlay").fadeOut(250, function () {
                        $("#cookie-select-overlay").remove();
                    })
                },
                error: function (data) {
                    $("#cookie-select-overlay").fadeOut(250, function () {
                        $("#cookie-select-overlay").remove();
                    })
                }
            });
        })

        $("#cookie-select-overlay").fadeIn(500);

        $("#cookie-select-overlay .details").click(function (e) {
            e.preventDefault();
            if ($("#cookie-select-overlay .details").html() == "Details anzeigen") {
                $("#cookie-select-overlay #notwendig-content").slideDown(500);
                $("#cookie-select-overlay .details").html("Details ausblenden");
            } else {
                $("#cookie-select-overlay #notwendig-content").slideUp(500);
                $("#cookie-select-overlay .details").html("Details anzeigen");
            }
        });
    }

}